<template>
  <form @submit.prevent="updateTranslations">
    <!--<div class="form-group">-->
      <!--<label for="product_ean" class="form-control-label">{{$t('product.ean')}}</label>-->
      <!--<input-->
        <!--id="product_ean"-->
        <!--v-model="item.ean"-->
        <!--:class="['form-control', isInvalid('ean') ? 'is-invalid' : '']"-->
        <!--type="text"-->
        <!--placeholder=""-->
        <!--@input="handleUpdateField('ean', $event.target.value)">-->
      <!--<div v-if="isInvalid('ean')" class="invalid-feedback">{{ violations.ean }}</div>-->
    <!--</div>-->

    <div class="form-group">
      <label for="product_company" class="form-control-label">{{$t('product.company.name')}}</label>

      <v-select
              id="product_company"
              v-model="item.company"
              :options="companies"
              :class="['form-control-select2', isInvalid('company') ? 'is-invalid' : '']"
              label="companyName"
              @search="loadCompanies"
      ></v-select>

      <div v-if="isInvalid('company')" class="invalid-feedback">{{ violations.company }}</div>
    </div>


    <div class="form-group">
      <label for="product_name" class="form-control-label">{{$t('product.name')}}</label>
      <input
          id="product_name"
          v-model="item.name"
          :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('name', $event.target.value)">
      <div v-if="isInvalid('name')" class="invalid-feedback">{{ violations.name }}</div>
    </div>






    <div class="form-group">
      <label for="product_category" class="form-control-label">{{$t('product.category.id')}}</label>

      <v-select
              id="product_category"
              v-model="item.category"
              :options="categories"
              :class="['form-control-select2', isInvalid('category') ? 'is-invalid' : '']"
              label="name"
      ></v-select>

      <div v-if="isInvalid('category')" class="invalid-feedback">{{ violations.category }}</div>
    </div>







    <div class="form-group">
      <label for="product_age" class="form-control-label">{{$t('product.age')}}</label>
      <input
          id="product_age"
          v-model="item.age"
          :class="['form-control', isInvalid('age') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('age', $event.target.value)">
      <div v-if="isInvalid('age')" class="invalid-feedback">{{ violations.age }}</div>
    </div>

    <div class="form-group">
      <label for="product_maxSize" class="form-control-label">{{$t('product.maxSize')}}</label>
      <input
          id="product_maxSize"
          v-model="item.maxSize"
          :class="['form-control', isInvalid('maxSize') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('maxSize', $event.target.value)">
      <div v-if="isInvalid('maxSize')" class="invalid-feedback">{{ violations.maxSize }}</div>
    </div>

    <div class="form-group">
      <label for="product_impressCount" class="form-control-label">{{$t('product.impressCount')}}</label>
      <input
          id="product_impressCount"
          v-model="item.impressCount"
          :class="['form-control', isInvalid('impressCount') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('impressCount', $event.target.value)">
      <div v-if="isInvalid('impressCount')" class="invalid-feedback">{{ violations.impressCount }}</div>
    </div>

    <div class="form-group">
      <label for="product_priceBuy" class="form-control-label">{{$t('product.priceBuy')}}</label>
      <input
          id="product_priceBuy"
          v-model.number="item.priceBuy"
          :class="['form-control', isInvalid('priceBuy') ? 'is-invalid' : '']"
          type="number"
          placeholder=""
          @input="handleUpdateField('priceBuy', parseInt($event.target.value))">
      <div v-if="isInvalid('priceBuy')" class="invalid-feedback">{{ violations.priceBuy }}</div>
    </div>


    <div class="form-group">
      <label for="product_currencyBuy" class="form-control-label">{{$t('product.currencyBuy.code')}}</label>

      <v-select
          id="product_currencyBuy"
          v-model="item.currencyBuy"
          :options="currencies"
          :class="['form-control-select2', isInvalid('currencyBuy') ? 'is-invalid' : '']"
          label="name"
      ></v-select>

      <div v-if="isInvalid('currencyBuy')" class="invalid-feedback">{{ violations.currencyBuy }}</div>
    </div>

    <div class="form-group">
      <label for="product_incotermBuy" class="form-control-label">{{$t('product.incotermBuy')}}</label>

      <v-select
          id="product_incotermBuy"
          v-model="item.incotermBuy"
          :options="incoterm"
          :class="['form-control-select2', isInvalid('incotermBuy') ? 'is-invalid' : '']"
          label="name"
      ></v-select>

      <div v-if="isInvalid('incotermBuy')" class="invalid-feedback">{{ violations.incotermBuy }}</div>
    </div>

    <div class="form-group">
      <label for="product_priceSell" class="form-control-label">{{$t('product.priceSell')}}</label>
      <input
          id="product_priceSell"
          v-model.number="item.priceSell"
          :class="['form-control', isInvalid('priceSell') ? 'is-invalid' : '']"
          type="number"
          placeholder=""
          @input="handleUpdateField('priceSell', parseInt($event.target.value))">
      <div v-if="isInvalid('priceSell')" class="invalid-feedback">{{ violations.priceSell }}</div>
    </div>

<!--    <div class="form-group">-->
<!--      <label for="product_priceOldSell" class="form-control-label">{{$t('product.priceOldSell')}}</label>-->
<!--      <input-->
<!--          id="product_priceOldSell"-->
<!--          v-model.number="item.priceOldSell"-->
<!--          :class="['form-control', isInvalid('priceOldSell') ? 'is-invalid' : '']"-->
<!--          type="number"-->
<!--          placeholder=""-->
<!--          @input="handleUpdateField('priceOldSell', parseInt($event.target.value))">-->
<!--      <div v-if="isInvalid('priceOldSell')" class="invalid-feedback">{{ violations.priceOldSell }}</div>-->
<!--    </div>-->

    <div class="form-group">
      <label for="product_currencySell" class="form-control-label">{{$t('product.currencySell.code')}}</label>

      <v-select
          id="product_currencySell"
          v-model="item.currencySell"
          :options="currencies"
          :class="['form-control-select2', isInvalid('currencySell') ? 'is-invalid' : '']"
          label="name"
      ></v-select>

      <div v-if="isInvalid('currencySell')" class="invalid-feedback">{{ violations.currencySell }}</div>
    </div>

    <div class="form-group">
      <label for="product_incotermSell" class="form-control-label">{{$t('product.incotermSell')}}</label>

      <v-select
          id="product_incotermSell"
          v-model="item.incotermSell"
          :options="incoterm"
          :class="['form-control-select2', isInvalid('incotermSell') ? 'is-invalid' : '']"
          label="name"
      ></v-select>

      <div v-if="isInvalid('incotermSell')" class="invalid-feedback">{{ violations.incotermSell }}</div>
    </div>

    <div class="form-group">
      <label for="product_transport" class="form-control-label">{{$t('product.transport')}}</label>
      <input
          id="product_transport"
          v-model="item.transport"
          :class="['form-control', isInvalid('transport') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('transport', $event.target.value)">
      <div v-if="isInvalid('transport')" class="invalid-feedback">{{ violations.transport }}</div>
    </div>

    <div class="form-group">
      <label for="product_availability" class="form-control-label">{{$t('product.availability')}}</label>
      <input
          id="product_availability"
          v-model="item.availability"
          :class="['form-control', isInvalid('availability') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('availability', $event.target.value)">
      <div v-if="isInvalid('availability')" class="invalid-feedback">{{ violations.availability }}</div>
    </div>

<!--    <div class="form-check" style="margin-bottom: 20px;">-->
<!--      <input-->
<!--          id="product_isSold"-->
<!--          v-model="item.isSold"-->
<!--          :class="['form-check-input', isInvalid('isSold') ? 'is-invalid' : '']"-->
<!--          type="checkbox"-->
<!--          placeholder=""-->
<!--          @input="handleUpdateField('isSold', $event.target.checked)">-->

<!--      <label for="product_isSold" class="form-check-label">{{$t('product.isSold')}}</label>-->

<!--      <div v-if="isInvalid('isSold')" class="invalid-feedback">{{ violations.isSold}}</div>-->
<!--    </div>-->




    <div class="form-group">
      <label for="product_status" class="form-control-label">{{$t('product.status.id')}}</label>

      <v-select
          id="product_status"
          v-model="item.status"
          :options="statuses"
          :class="['form-control-select2', isInvalid('status') ? 'is-invalid' : '']"
          label="name"
      ></v-select>

      <div v-if="isInvalid('status')" class="invalid-feedback">{{ violations.status }}</div>
    </div>



    <div class="form-check" style="margin-bottom: 20px;">
      <input
          id="product_priceOnRequest"
          v-model="item.priceOnRequest"
          :class="['form-check-input', isInvalid('priceOnRequest') ? 'is-invalid' : '']"
          type="checkbox"
          placeholder=""
          @input="handleUpdateField('priceOnRequest', $event.target.checked)">

      <label for="product_priceOnRequest" class="form-check-label">{{$t('product.priceOnRequest')}}</label>

      <div v-if="isInvalid('priceOnRequest')" class="invalid-feedback">{{ violations.priceOnRequest}}</div>
    </div>



    <div class="form-group">
      <label for="product_condition" class="form-control-label">{{$t('product.condition')}}</label>

      <v-select
          id="product_condition"
          v-model="item.condition"
          :options="conditions"
          :class="['form-control-select2', isInvalid('condition') ? 'is-invalid' : '']"
          label="name"
      ></v-select>

      <div v-if="isInvalid('condition')" class="invalid-feedback">{{ violations.condition }}</div>
    </div>

    <div class="form-group">
      <label for="product_colors" class="form-control-label">{{$t('product.colors')}}</label>
      <input
          id="product_colors"
          v-model="item.colors"
          :class="['form-control', isInvalid('colors') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('colors', $event.target.value)">
      <div v-if="isInvalid('colors')" class="invalid-feedback">{{ violations.colors }}</div>
    </div>

    <div class="form-group">
      <label for="product_video" class="form-control-label">{{$t('product.video')}}</label>
      <input
          id="product_video"
          v-model="item.video"
          :class="['form-control', isInvalid('video') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('video', $event.target.value)">
      <div v-if="isInvalid('video')" class="invalid-feedback">{{ violations.video }}</div>
    </div>
    <div class="form-check" style="margin-bottom: 20px;">
      <input
              id="product_isActive"
              v-model="item.isActive"
              :class="['form-check-input', isInvalid('isActive') ? 'is-invalid' : '']"
              type="checkbox"
              placeholder=""
              @input="handleUpdateField('isActive', $event.target.checked)">

      <label for="product_isActive" class="form-check-label">{{$t('product.isActive')}}</label>

      <div v-if="isInvalid('isActive')" class="invalid-feedback">{{ violations.isActive }}</div>
    </div>
    <div class="nav-tabs-custom">
      <ul class="nav nav-tabs">
        <li :class="{active: i === 0}" v-for="(translation, i) in translations" :key="translation.language.id">
          <a :href="'#' + translation.language.code" data-toggle="tab" aria-expanded="false">{{translation.language.name}}</a>
        </li>
      </ul>
      <div class="tab-content">
        <div :class="['tab-pane', {active: i === 0}]" :id="translation.language.code" v-for="(translation, i) in translations" :key="translation.language.id">

          <div class="form-group">
            <label for="product_description" class="form-control-label">{{$t('product.description')}}</label>
            <textarea
                    id="product_description"
                    v-model="translation.description"
                    :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
                    rows="15"
            ></textarea>
            <div v-if="isInvalid('description')" class="invalid-feedback">{{ violations.description }}</div>
          </div>
        </div>
      </div>
    </div>

    <upload-image :item="item" property="images" :multiple="true" label="Images"></upload-image>

    <item-edit-actions :item="item" :entity="'Product'" :path="'product'"></item-edit-actions>
  </form>
</template>

<script>
import ItemEditActions from '../layout/ItemEditActions'
import { mapActions } from 'vuex'
import UploadImage from '../layout/UploadImage'
// import vueDropzone from "vue2-dropzone";
import fetch from '../../utils/fetch'

export default {
  components: {
    ItemEditActions,
    UploadImage
    // vueDropzone
  },

  props: {

    handleUpdateField: {
      type: Function,
      required: true
    },
    handleSubmit: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    violations () {
      return this.errors || {}
    },

    categories () {
      return this.$store.getters['category/list/items'] || []
    },

    statuses () {
      return this.$store.getters['product_status/list/items'] || []
    },

    companies () {
      return this.$store.getters['company/list/items']
    },

    conditions () {
      return this.$store.getters['condition/list/items'] || []
    },

    incoterm () {
      return this.$store.getters['incoterm/list/items'] || []
    },

    languages () {
      return this.$store.getters['language/list/items'] || []
    },

    currencies () {
      return this.$store.getters['currency/list/items'] || []
    },
    translations: {
      get () {
        let translations = [];

        this.languages.forEach(language => {
          translations.push(this.findItem(language))
        });

        return translations
      },
      set (v) {
        console.log('set', v)
      }
    },

    authHeader () {
      return 'Bearer ' + this.$store.state.auth.token
    }
  },

  created () {
    this.getLanguages()
    this.getConditions()
    this.getCurrencies()
    this.getStatuses()
    this.getCategories('/categories?itemsPerPage=500')
    this.getIncoterms()
  },

  methods: {
    updateTranslations () {
      this.item.translations = this.translations.filter(translation => {
        return translation.description && translation.description !== ''
      })

      this.handleSubmit(this.item)
    },

    findItem (language) {
      let translation = {
        language: language,
      };

      this.item.translations.some(element => {
        if (element.language.code === language.code) {
          translation = element
        }
      });

      return translation
    },

    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },

    ...mapActions({
      getIncoterms: 'incoterm/list/default',
      getCategories: 'category/list/default',
      getStatuses: 'product_status/list/default',
      getCompanies: 'company/list/default',
      getConditions: 'condition/list/default',
      getLanguages: 'language/list/default',
      getCurrencies: 'currency/list/default',
    }),
    loadCompanies (keyword, loading) {
      loading(true);

      this.searchCompanies(loading, keyword, this);
    },
    searchCompanies: _.debounce((loading, keyword, vm) => {
      vm.getCompanies('/companies?code=' + keyword)
      loading(false);
    }, 350),
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product/Form.vue